import React from 'react';
import PropTypes from 'prop-types';

/**
 * TabList - A wrapper that renders a standard HTML ul for Bulma tabs
 * 
 * This component accepts the same props as Bloomer TabList for easy migration
 */
const TabList = ({
  className,
  style,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = [];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <ul 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </ul>
  );
};

TabList.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

TabList.defaultProps = {
  className: '',
  style: {},
  children: null
};

export default TabList;
